import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, DispatchCompleteLoadSession } from "@insite/client-framework/Store/Context/Handlers/LoadSession";
import { getPolicy } from "@store/Framework/Store/Store/Data/getPolicy";

addToChainAfter(chain, DispatchCompleteLoadSession, props => {
    const state = props.getState();
    if (state.context.areSettingsLoaded) {
        const session = props.apiResult;
        const canSeePrice = getPolicy(state, "Pricing.CanSeePrice");
        if (!session || (session && !canSeePrice)) {
            const settings = getSettingsCollection(state);
            let newSettings = {
                ...settings,
                productSettings: {
                    ...settings.productSettings,
                    canSeePrices: false,
                },
            };
            props.dispatch({
                type: "Context/CompleteLoadSettings",
                settings: { settingsCollection: newSettings },
            });
        }
    }
});
